<template>
  <ls-table-layout>
    <template #search>
      <SearchForm ref="searchFormRef" @search="onSearch" />
    </template>
    <div class="table-page-operator-wrapper scheduling-operator-wrapper" slot="btn">
      <div class="left-operator">
        <div class="normal-operator-btns">
          <download-modal :apiFun="apiMesProcessSchedulingExport" ref="download" />
          <a-button
            :disabled="selectedRows.length === 0"
            @click="handlePrintSchedulingDetail"
            v-hasPermi="['mes:mesProcessScheduling:list']"
          >
            打印排单明细
          </a-button>
          <a-button @click="handleExport">导出</a-button>
        </div>
      </div>
      <div>
        <a-button
          type="primary"
          :loading="btnLoading"
          :disabled="selectedRows.length === 0"
          @click="handleConfirmComplete"
        >
          确认完工
        </a-button>
      </div>
    </div>
    <template v-slot:table>
      <div class="page-header-content has-custom-expand">
        <a-tabs
          type="card"
          :active-key="activeMainProcessCode || '__none__'"
          @change="handleMainProcessQuickSearch"
        >
          <a-tab-pane
            v-for="item in permittedMainProcessOptions"
            :key="item.lookupCode"
            :tab="item.lookupValue"
          />
        </a-tabs>
        <ls-api-table
          ref="baseTable"
          row-key="id"
          :columns="dyCols"
          :table-props="tableProps"
          :scroll="{ fixScreen: true, x: scrollX }"
          :pagination="pagination"
          :selection="selection"
          :multi-select="true"
          :selected-rows.sync="selectedRows"
          :custom-selection="selectionConfig"
          :expanded-row-keys.sync="expandedRowKeys"
          :expanded-row-render="expandedRowRender"
          @selectedRowChange="selectedRowChange"
          @successCallBack="handleTableLoad"
        >
          <template #orderNo="{ record }">
            <span class="plan-order-cell">
              <a-icon
                v-if="hasLineList(record)"
                class="expand-toggle-icon"
                :type="isRowExpanded(record.id) ? 'minus-square' : 'plus-square'"
                @click.stop="toggleExpand(record)"
              />
              <span class="plan-order-text">{{ record.orderNo }}</span>
            </span>
          </template>
          <template #orderNoTitle>
            <span class="plan-order-header">
              <a-icon
                class="expand-toggle-icon"
                :type="allExpanded ? 'minus-square' : 'plus-square'"
                @click.stop="toggleExpandAll"
              />
              <span>计划单号</span>
            </span>
          </template>
          <template #formatDate="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template #textEllipsis="{ text }">
            <a-tooltip :title="text"><div class="text-3-ellipsis">{{ text }}</div></a-tooltip>
          </template>
        </ls-api-table>
      </div>
      <print-scheduling-detail-modal ref="printSchedulingDetailModalRef" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import SearchForm from './components/search-form.vue'
import ExpandSubTable from './components/expand-sub-table.vue'
import PrintSchedulingDetailModal from './components/print-scheduling-detail-modal.vue'
import { SCHEDULING_INFO_COL } from './common'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { apiLookupDataList } from '@/api/system/lookup/look-up-detail'
import {
  apiMesProcessSchedulingComplete,
  apiMesProcessSchedulingExport,
  apiMesProcessSchedulingList
} from '@/api/mes/workOrderManage/ouKangOrderScheduling'

export default {
  name: 'OuKangOrderScheduling',
  components: {
    DownloadModal,
    PrintSchedulingDetailModal,
    SearchForm
  },
  data () {
    return {
      apiMesProcessSchedulingExport,
      dyCols: SCHEDULING_INFO_COL,
      tableData: [],
      expandedRowKeys: [],
      selectedRowKeys: [],
      selectedRows: [],
      mainProcessOptions: [],
      activeMainProcessCode: undefined,
      selection: true,
      btnLoading: false,
      currentPageIs: false,
      pagination: {
        pageSizeOptions: ['20', '50', '100', '500']
      }
    }
  },
  computed: {
    scrollX () {
      return this.dyCols.reduce((acc, cur) => acc + (cur.width || 120), 200)
    },
    tableProps () {
      return {
        requestApi: generateLsTableResData(apiMesProcessSchedulingList),
        pageCurrent: false
      }
    },
    selectionConfig () {
      return {
        stickyFixed: 'left',
        columnWidth: 48
      }
    },
    permittedMainProcessOptions () {
      return this.mainProcessOptions.filter(item => this.hasLookupPermission(item.attribute1))
    },
    expandableRowKeys () {
      return this.tableData
        .filter(item => this.hasLineList(item))
        .map(item => item.id)
    },
    allExpanded () {
      return this.expandableRowKeys.length > 0 &&
        this.expandableRowKeys.every(id => this.expandedRowKeys.includes(id))
    }
  },
  created () {
    this.loadMainProcessOptions()
  },
  mounted () {
    this.$refs.searchFormRef.handleSearch()
  },
  methods: {
    loadMainProcessOptions () {
      apiLookupDataList({ lookupType: 'MES_MAIN_PROCESS', current: 1, pageSize: 999 }).then(res => {
        this.mainProcessOptions = res.rows || res.data || []
      })
    },
    hasLookupPermission (permissionCodes) {
      const allPermission = '*:*:*'
      const permissions = this.$store.getters.permissions || []
      const codeList = `${permissionCodes || ''}`
        .split(/[,，\s]+/)
        .map(item => item.trim())
        .filter(Boolean)
      if (!codeList.length) {
        return false
      }
      return permissions.some(permission => {
        return permission === allPermission || codeList.includes(permission)
      })
    },
    expandedRowRender (record) {
      return this.$createElement(ExpandSubTable, {
        key: record.id,
        props: { record },
        on: {
          refresh: () => this.refreshList(true)
        }
      })
    },
    hasLineList (record) {
      return Array.isArray(record.lineList) && record.lineList.length > 0
    },
    isRowExpanded (id) {
      return this.expandedRowKeys.includes(id)
    },
    handleTableLoad (data) {
      this.tableData = Array.isArray(data) ? data : []
      this.expandedRowKeys = [...this.expandableRowKeys]
    },
    toggleExpandAll () {
      this.expandedRowKeys = this.allExpanded ? [] : [...this.expandableRowKeys]
    },
    toggleExpand (record) {
      if (!this.hasLineList(record)) {
        return
      }
      const key = record.id
      if (this.isRowExpanded(key)) {
        this.expandedRowKeys = this.expandedRowKeys.filter(item => item !== key)
      } else {
        this.expandedRowKeys = [...this.expandedRowKeys, key]
      }
    },
    onSearch (params) {
      this.expandedRowKeys = []
      this.activeMainProcessCode = params.mainProcessCode
      this.$refs.baseTable.searchParams = { ...params }
      this.$refs.baseTable.getData(this.currentPageIs)
      this.currentPageIs = false
    },
    refreshList (currentPageIs) {
      this.$nextTick(() => {
        this.currentPageIs = !!currentPageIs
        this.$refs.searchFormRef.handleSearch()
      })
    },
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleMainProcessQuickSearch (lookupCode) {
      this.activeMainProcessCode = lookupCode
      this.$refs.searchFormRef.queryParams.mainProcessCode = lookupCode
      this.$refs.searchFormRef.handleSearch()
    },
    handlePrintSchedulingDetail () {
      if (!this.selectedRows.length) {
        return this.$message.warning('请至少勾选一条单据进行打印')
      }
      if (!this.$refs.printSchedulingDetailModalRef) {
        return this.$message.error('打印组件未加载，请刷新页面后重试')
      }
      this.$refs.printSchedulingDetailModalRef.show(this.selectedRows)
    },
    handleExport () {
      const params = this.$refs.baseTable ? this.$refs.baseTable.searchParams : {}
      this.$refs.download.openModal({ ...params })
    },
    async handleConfirmComplete () {
      if (!this.selectedRows.length) {
        return this.$message.warning('请至少勾选一条单据进行操作')
      }
      this.btnLoading = true
      try {
        for (const row of this.selectedRows) {
          const res = await apiMesProcessSchedulingComplete(row.id)
          if (res.code !== 200) {
            this.$message.error(res.msg || '操作失败')
            return
          }
        }
        this.$message.success('操作成功')
        this.selectedRows = []
        this.selectedRowKeys = []
        this.expandedRowKeys = []
        this.refreshList()
      } finally {
        this.btnLoading = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.scheduling-operator-wrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.left-operator,
.normal-operator-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.page-header-content {
  &.has-custom-expand {
    /deep/ col.ant-table-expand-icon-col {
      width: 0 !important;
    }
    /deep/ .ant-table-expand-icon-th,
    /deep/ .ant-table-row-expand-icon-cell {
      width: 0 !important;
      min-width: 0 !important;
      max-width: 0 !important;
      padding: 0 !important;
      border: none !important;
      overflow: hidden;
    }
    /deep/ .ant-table-selection-column {
      width: 48px !important;
      min-width: 48px !important;
      max-width: 48px !important;
    }
    /deep/ .plan-order-no-col {
      min-width: 140px !important;
      width: 140px !important;
    }
  }
  /deep/ .ant-table-expanded-row > td {
    padding: 8px 0 !important;
    background: #fafafa;
    overflow: hidden;
  }
  /deep/ .ant-table-expanded-row:hover > td {
    background: #fafafa !important;
  }
  /deep/ .ant-table-expanded-row > td > .ant-table-wrapper {
    margin: 0;
  }
}

.plan-order-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  max-width: 100%;
  .plan-order-text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.expand-toggle-icon {
  color: #1890ff;
  cursor: pointer;
  font-size: 14px;
  flex-shrink: 0;
}

.plan-order-header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
</style>
